import { i18n } from 'i18n';

export const OFFER_CATEGORIES: { [key: string]: string } = {
	adult: i18n.t('Для взрослых'),
	clothes: i18n.t('Одежда'),
	beauty: i18n.t('Красота'),
	electronics: i18n.t('Электроника'),
	digital: i18n.t('Цифровые услуги'),
	travel: i18n.t('Путешествия'),
	pets: i18n.t('Питомцы'),
	baby: i18n.t('Детские товары'),
	home_garden: i18n.t('Дом и сад'),
	cars_and_bikes: i18n.t('Авто и мотоциклы'),
	gifts_and_flowers: i18n.t('Подарки и цветы'),
	food: i18n.t('Еда'),
	sports_and_outdoor: i18n.t('Спорт и активный отдых'),
	finance_and_insurance: i18n.t('Финансы и страхование'),
	hobbies: i18n.t('Хобби и развлечения'),
	books: i18n.t('Книги'),
};
